import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";

const emails = ["username@gmail.com", "user02@gmail.com"];
const useStyles = makeStyles({
  // imageContainer: {
  //   // position: "relative",
  //   // display:'flex',
  //   // justifyContent:'center'
  // },
  image: {
    maxWidth: "100%",
    maxHeight: "100%",
    height: "auto",
  },
});

export default function DrawingDialog(props) {
  const classes = useStyles();
  const { onClose, drawing, open } = props;

    const handleClose = () => {
      onClose();
      console.log('closed');
    };

  //   const handleListItemClick = (value) => {
  //     onClose(value);
  //   };

  return (
    <Dialog
    fullWidth={true}
        onClose={handleClose}
      aria-labelledby="drawing-dialog"
      open={open}
    >
      <DialogTitle id="drawing-dialog">Student Drawing</DialogTitle>
      <Box  m={4} display="flex" justifyContent="center">
        <img className={classes.image} src={drawing} alt="student drawing" />
      </Box>
    </Dialog>
  );
}
